import type React from 'react'

import { SkeletonBlock } from './SkeletonBlock'

interface SkeletonButtonRowProps {
  buttons?: number
}

export const SkeletonButtonRow: React.FC<SkeletonButtonRowProps> = ({ buttons = 2 }) => (
  <div
    className="mt-4 flex justify-end gap-gap-sm border-t border-border-lighter pt-4"
    aria-hidden="true"
  >
    {Array.from({ length: buttons }, (_, index) => (
      <SkeletonBlock key={index} className="h-10 w-28" />
    ))}
  </div>
)
